<<template>
  <div style="margin-top: 15px;">
    <SettingForm :data="formData" @sendData='updateData' />
  </div>
</template>

  <script>
  import axios from 'axios';
  import SettingForm from './settingForm.vue';
  export default {
    data() {
      return {
        formData: {}
      }
    },
    components: { SettingForm },
    created() {
      this.setData();
    },
    methods: {
      setData() {
        const { query } = this.$route;
        const enabled = !!query.actived;
        this.formData = { enabled, ...query };
      },
      updateData(data) {
        const { id } = this.$route.query
        const obj = { id, ...data }
        axios.post(`/pmdm/admin/adminIntegrationApi/saveOrUpdate`, obj).then(res => {
          this.$message.success(res.data.message);
          // this.formData = { ...obj }

        })
      },

    },

  }
</script>

  <style scoped></style>